<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<br/><p style="text-indent:00em;">Thanks to Alamelu and Anumarla Govindan, PhD for sharing their first-hand knowledge of South India and its customs. And Stephen Biesty and Richard Platt for the information on ships and sailing in their book, <em>‘The Coolest Cross-Sections Ever’.</em></p>
<br/><p style="text-indent:00em;">Also, Miles F. Potter’s, <em>‘Oregon’s Golden Years’</em> for information on the gold rush in Baker County, Oregon.</p>
<br/><p style="text-indent:00em;">The cover illustration: <em>‘Unicorn in a Misty Forest Glade’</em> was prepared by C. Atkinson. It is available at www.shutterpoint.com.</p>
<br/><p style="text-indent:00em;">Typography and maps were prepared by the author.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?0488b43e